module.exports = __webpack_public_path__ + "img/CS-Hybrid_Ad-Std_1.e902a26b.jpg";